(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amana-influenceuses"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('amana-influencers')) {
  customElements.define('amana-influencers', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.nearObserver?.disconnect();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      if (this.dataset.shuffle === 'true' && !this.shuffled) this.shuffle();
      this.autoQueue = new Set();
      const selected = this.querySelector('[data-story]:not([hidden]) .am-social__media');
      if (selected) this.autoQueue.add(selected);
      this.soundOn = this.dataset.soundDefault === 'true';
      this.rail = this.querySelector('[data-profiles]');
      this.autoRun = 0;
      ['pointerdown', 'keydown', 'touchstart'].forEach(type => this.addEventListener(type, () => { this.autoRun = 0; }, { signal, passive: true }));
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-profile]');
        if (button) this.select(button.dataset.profile);
        const play = event.target.closest('[data-play]');
        if (play) this.play(play.closest('[data-story]'));
        const step = event.target.closest('[data-step]');
        if (step) this.step(Number(step.dataset.step));
      }, { signal });
      const anticipate = (event) => {
        const profile = event.target.closest?.('[data-profile]');
        if (profile) this.prepare(this.panels().find(panel => panel.dataset.story === profile.dataset.profile), 'auto');
        const step = event.target.closest?.('[data-step]');
        if (step) this.prepare(this.neighbour(Number(step.dataset.step)), 'auto');
      };
      ['pointerover', 'pointerdown', 'focusin'].forEach(type => this.addEventListener(type, anticipate, { signal, passive: true }));
      if (this.rail) {
        this.rail.addEventListener('keydown', (event) => {
          const keys = { ArrowLeft: -1, ArrowRight: 1 };
          if (!(event.key in keys) || !event.target.closest('[data-profile]')) return;
          event.preventDefault();
          this.step(keys[event.key], true);
        }, { signal });
        this.setupLoop();
        this.rail.addEventListener('scroll', () => {
          this.updateRail();
          if (!('onscrollend' in window)) { clearTimeout(this.scrollTimer); this.scrollTimer = setTimeout(() => this.recenter(), 150); }
        }, { signal, passive: true });
        this.rail.addEventListener('scrollend', () => this.recenter(), { signal });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => { this.recenter(); this.updateRail(); });
          this.resizeObserver.observe(this.rail);
        }
        this.updateRail();
      }
      this.querySelectorAll('.am-social__media').forEach(media => this.bindSwipe(media));
      this.reviewBox = this.querySelector('.am-social__reviews');
      if (this.reviewBox && 'ResizeObserver' in window) {
        this.reviewObserver = new ResizeObserver(() => this.packReviews());
        this.reviewObserver.observe(this.reviewBox);
        document.fonts?.ready.then(() => this.packReviews(true));
      }
      document.addEventListener('shopify:block:select', (event) => {
        if (this.contains(event.target)) this.select(event.detail.blockId);
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.querySelectorAll('video').forEach(video => this.pauseForVisibility(video));
        else this.autoQueue.forEach(media => this.tryAutoplay(media));
      }, { signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const media = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.25) this.tryAutoplay(media);
            else { const video = media.querySelector('video'); if (video) this.pauseForVisibility(video); }
          });
        }, { threshold: [0, 0.25] });
        this.querySelectorAll('.am-social__media').forEach(media => this.observer.observe(media));
        this.nearObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => { const panel = entry.target.closest('[data-story]'); if (entry.isIntersecting && !panel.hidden) this.prepare(panel, 'poster'); });
        }, { rootMargin: '50% 0px' });
        this.querySelectorAll('.am-social__media').forEach(media => this.nearObserver.observe(media));
      } else if (selected) this.tryAutoplay(selected);
      this.querySelectorAll('video').forEach(video => this.bindVideo(video));
    }
    packReviews(force = false) {
      const box = this.reviewBox;
      const width = box.clientWidth;
      if (!force && width === this.reviewWidth) return;
      this.reviewWidth = width;
      this.reviewCards = this.reviewCards || [...box.querySelectorAll('.am-social__review')].map(card => ({ card, column: card.parentElement }));
      this.reviewCards.forEach(({ card, column }) => column.append(card));
      box.querySelectorAll('.am-social__review-slide').forEach(slide => slide.remove());
      if (!window.matchMedia('(max-width: 599px)').matches || this.reviewCards.length < 3) return;
      const gap = 12;
      const cards = this.reviewCards.map(({ card }) => ({ card, height: card.getBoundingClientRect().height }));
      const limit = Math.max(...cards.map(item => item.height)) * 1.1;
      const slides = [];
      cards.forEach(item => {
        const slot = slides.find(slide => slide.length === 1 && slide[0].height + gap + item.height <= limit);
        if (slot) slot.push(item);
        else slides.push([item]);
      });
      box.append(...slides.map(group => {
        const slide = document.createElement('div');
        slide.className = 'am-social__review-slide';
        slide.append(...group.map(item => item.card));
        return slide;
      }));
    }
    shuffle() {
      this.shuffled = true;
      const rail = this.querySelector('[data-profiles]');
      const buttons = [...rail.querySelectorAll('[data-profile]:not([data-clone])')];
      const panels = this.panels();
      if (panels.length < 2) return;
      const order = panels.map((_, index) => index);
      for (let index = order.length - 1; index > 0; index--) {
        const other = Math.floor(Math.random() * (index + 1));
        [order[index], order[other]] = [order[other], order[index]];
      }
      rail.append(...order.map(index => buttons[index]));
      panels[0].parentElement.append(...order.map(index => panels[index]));
      const first = panels[order[0]].dataset.story;
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.profile === first)));
      panels.forEach(panel => { panel.hidden = panel.dataset.story !== first; });
      const poster = panels[order[0]].querySelector('template[data-poster]');
      if (poster) poster.replaceWith(poster.content.cloneNode(true));
    }
    pauseForVisibility(video) {
      if (!video.paused && !video.ended && !video.closest('[data-story]').hidden) this.autoQueue.add(video.closest('.am-social__media'));
      video.pause();
    }
    tryAutoplay(media) {
      const panel = media.closest('[data-story]');
      const rect = media.getBoundingClientRect();
      const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
      if (!this.autoQueue.has(media) || panel.hidden || document.hidden || !rect.height || visibleHeight < rect.height * 0.25) return;
      this.autoQueue.delete(media);
      this.play(panel, true);
    }
    pauseVideos() { this.querySelectorAll('video').forEach(video => video.pause()); }
    scrollBehavior() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    panels() { return [...this.querySelectorAll('[data-story]')]; }
    currentIndex() { return this.panels().findIndex(panel => !panel.hidden); }
    step(direction, focus = false) {
      const panels = this.panels();
      if (panels.length < 2) return;
      const next = panels[(this.currentIndex() + direction + panels.length) % panels.length];
      this.select(next.dataset.story);
      if (focus) this.querySelector(`[data-profile="${next.dataset.story}"]:not([data-clone])`)?.focus({ preventScroll: true });
    }
    setupLoop() {
      const rail = this.rail;
      rail.querySelectorAll('[data-clone]').forEach(clone => clone.remove());
      this.looping = false;
      const items = [...rail.querySelectorAll('[data-profile]')];
      if (items.length < 2 || rail.scrollWidth - rail.clientWidth <= 2) return;
      const cloneOf = (item) => {
        const clone = item.cloneNode(true);
        [...clone.attributes].forEach(attribute => { if (attribute.name.startsWith('data-shopify')) clone.removeAttribute(attribute.name); });
        clone.removeAttribute('aria-controls');
        clone.setAttribute('aria-hidden', 'true');
        clone.tabIndex = -1;
        clone.dataset.clone = '';
        return clone;
      };
      rail.prepend(...items.map(cloneOf));
      rail.append(...items.map(cloneOf));
      this.looping = true;
      rail.scrollLeft = this.loopWidth();
    }
    loopWidth() {
      return this.rail.querySelector('[data-profile]:not([data-clone])').offsetLeft - this.rail.firstElementChild.offsetLeft;
    }
    recenter() {
      if (!this.looping) return;
      const width = this.loopWidth();
      if (this.rail.scrollLeft < width * 0.5) this.rail.scrollLeft += width;
      else if (this.rail.scrollLeft > width * 1.5) this.rail.scrollLeft -= width;
    }
    updateRail() {
      const rail = this.rail;
      if (!rail) return;
      const box = rail.parentElement;
      const max = rail.scrollWidth - rail.clientWidth;
      const start = !this.looping && rail.scrollLeft <= 2;
      const end = !this.looping && rail.scrollLeft >= max - 2;
      box.toggleAttribute('data-overflow', max > 2);
      box.toggleAttribute('data-scrolled', !start);
      box.toggleAttribute('data-end', end);
    }
    revealProfile(id) {
      const rail = this.rail;
      if (!rail || rail.scrollWidth <= rail.clientWidth) return;
      const center = rail.scrollLeft + rail.clientWidth / 2;
      const distance = (button) => Math.abs(button.offsetLeft - rail.offsetLeft + button.offsetWidth / 2 - center);
      const button = [...rail.querySelectorAll(`[data-profile="${id}"]`)].sort((a, b) => distance(a) - distance(b))[0];
      if (!button) return;
      const left = button.offsetLeft - rail.offsetLeft;
      if (left >= rail.scrollLeft && left + button.offsetWidth <= rail.scrollLeft + rail.clientWidth) return;
      rail.scrollTo({ left: left - (rail.clientWidth - button.offsetWidth) / 2, behavior: this.scrollBehavior() });
    }
    bindSwipe(media) {
      let start = null;
      const options = { signal: this.controller.signal, passive: true };
      media.addEventListener('touchstart', (event) => {
        const touch = event.touches[0];
        const rect = media.getBoundingClientRect();
        start = event.touches.length === 1 && touch.clientY < rect.bottom - 64 ? { x: touch.clientX, y: touch.clientY } : null;
      }, options);
      media.addEventListener('touchend', (event) => {
        if (!start) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - start.x;
        const dy = touch.clientY - start.y;
        start = null;
        if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) this.step(dx < 0 ? 1 : -1);
      }, options);
    }
    select(id) {
      if (!this.panels().some(panel => panel.dataset.story === id)) return;
      this.querySelectorAll('[data-profile]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.profile === id)));
      this.revealProfile(id);
      this.querySelectorAll('[data-story]').forEach(panel => {
        panel.hidden = panel.dataset.story !== id;
        if (panel.hidden) {
          this.autoQueue.delete(panel.querySelector('.am-social__media'));
          panel.querySelector('video')?.pause();
        }
        else {
          const poster = panel.querySelector('template[data-poster]');
          if (poster) { poster.replaceWith(poster.content.cloneNode(true)); }
          const media = panel.querySelector('.am-social__media');
          this.autoQueue.add(media);
          this.tryAutoplay(media);
        }
      });
    }
    bindVideo(video) {
      const media = video.closest('.am-social__media');
      const button = media.querySelector('[data-play]');
      const status = media.querySelector('[data-video-status]');
      const options = { signal: this.controller.signal };
      video.addEventListener('playing', () => {
        if (video.closest('[data-story]').hidden || document.hidden) { video.pause(); return; }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(() => { media.dataset.started = ''; });
        else media.dataset.started = '';
        button.hidden = true;
        status.hidden = true;
        clearTimeout(this.nextTimer);
        this.nextTimer = setTimeout(() => { if (!video.paused) this.prepare(this.neighbour(1), this.richPreload() ? 'auto' : 'poster'); }, 1000);
      }, options);
      video.addEventListener('pause', () => { status.hidden = true; }, options);
      video.addEventListener('error', () => this.showError(media), options);
      video.addEventListener('volumechange', () => {
        if (video.muted !== video.expectMuted && !video.closest('[data-story]').hidden) this.soundOn = !video.muted;
        video.expectMuted = video.muted;
      }, options);
      video.addEventListener('ended', () => {
        if (this.querySelector('.am-social__stories')?.dataset.autoadvance !== 'true' || video.closest('[data-story]').hidden || document.hidden) return;
        this.autoRun += 1;
        if (this.autoRun >= this.panels().length) { this.autoRun = 0; return; }
        this.step(1);
      }, options);
    }
    showError(media) {
      const status = media.querySelector('[data-video-status]');
      status.textContent = status.dataset.error;
      status.hidden = false;
      media.querySelector('[data-play]').hidden = false;
    }
    createVideo(media, preload = 'none') {
      const template = media.querySelector('template[data-video]');
      if (!template) return null;
      const video = template.content.firstElementChild.cloneNode(true);
      const sources = [...video.querySelectorAll('source')];
      const hls = sources.find(source => source.dataset.format === 'm3u8');
      const mp4 = sources.filter(source => source.dataset.format === 'mp4').sort((a, b) => Number(a.dataset.width) - Number(b.dataset.width));
      const frameWidth = media.clientWidth || this.querySelector('[data-story]:not([hidden]) .am-social__media')?.clientWidth || 0;
      const targetWidth = frameWidth * (navigator.connection?.saveData ? 1 : Math.min(window.devicePixelRatio || 1, 1.5));
      const canHls = Boolean(hls && video.canPlayType(hls.type));
      const slow = this.lowData() || /3g/.test(navigator.connection?.effectiveType || '');
      const bestMp4 = mp4.find(source => Number(source.dataset.width) >= targetWidth) || mp4[mp4.length - 1];
      const short = Number(video.dataset.duration) > 0 && Number(video.dataset.duration) <= 20000;
      const source = (canHls && (slow || !short) ? hls : bestMp4) || (canHls ? hls : sources[0]);
      if (!source) return null;
      video.preload = preload;
      video.src = source.dataset.src;
      sources.forEach(source => source.remove());
      media.prepend(video);
      this.bindVideo(video);
      return video;
    }
    lowData() {
      const connection = navigator.connection;
      return Boolean(connection?.saveData || /2g/.test(connection?.effectiveType || ''));
    }
    richPreload() {
      const type = navigator.connection?.effectiveType;
      return !this.lowData() && (!type || type === '4g') && window.matchMedia('(min-width: 990px)').matches;
    }
    prepare(panel, level = 'poster') {
      if (!panel) return;
      const poster = panel.querySelector('template[data-poster]');
      if (poster) poster.replaceWith(poster.content.cloneNode(true));
      if (level === 'poster' || this.lowData()) return;
      const media = panel.querySelector('.am-social__media');
      const existing = media.querySelector('video');
      if (existing) {
        if (level === 'auto' && existing.preload !== 'auto') existing.preload = 'auto';
        return;
      }
      const video = this.createVideo(media, level);
      if (!video) return;
      this.prepared = [...(this.prepared || []).filter(item => item.isConnected), video];
      const idle = this.prepared.filter(item => item.closest('[data-story]').hidden && !item.closest('.am-social__media').hasAttribute('data-started'));
      idle.slice(0, Math.max(0, idle.length - 3)).forEach(item => {
        item.removeAttribute('src');
        item.load();
        item.remove();
      });
    }
    neighbour(direction) {
      const panels = this.panels();
      return panels.length > 1 ? panels[(this.currentIndex() + direction + panels.length) % panels.length] : null;
    }
    setMuted(video, muted) {
      video.expectMuted = muted;
      video.muted = muted;
    }
    play(panel, automatic = false, forceMuted = false) {
      if (panel.hidden) return;
      const media = panel.querySelector('.am-social__media');
      let video = media.querySelector('video');
      if (!video) {
        if (!media.querySelector('template[data-video]')) return;
        video = this.createVideo(media);
        if (!video) { this.showError(media); return; }
      } else if (video.error) video.load();
      this.setMuted(video, forceMuted || !this.soundOn);
      media.querySelector('[data-play]').hidden = true;
      const status = media.querySelector('[data-video-status]');
      status.hidden = true;
      video.play().then(() => {
        if (panel.hidden || document.hidden || !this.isConnected) { video.pause(); return; }
        if (!automatic) video.focus({ preventScroll: true });
      }).catch(error => {
        if (error.name === 'NotAllowedError' && !video.muted) {
          this.play(panel, automatic, true);
        } else if (automatic && error.name === 'NotAllowedError') {
          status.hidden = true;
          media.querySelector('[data-play]').hidden = false;
        } else if (error.name !== 'AbortError') this.showError(media);
      });
    }
    disconnectedCallback() {
      clearTimeout(this.scrollTimer);
      clearTimeout(this.nextTimer);
      this.controller?.abort();
      this.observer?.disconnect();
      this.nearObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.reviewObserver?.disconnect();
      this.pauseVideos();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
